// extracted by mini-css-extract-plugin
export default {"loginEnter":"LoginForm_loginEnter__B4qVj","loginUnverified":"LoginForm_loginUnverified__xr8Tl","qrText":"LoginForm_qrText__YEGB2"};